var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 383,
    height: 379,
    viewBox: "0 0 383 379",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_630_2432",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 383,
    height: 371
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    width: 383,
    height: 371,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_630_2432)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_630_2432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3995 245.08C22.0188 221.531 34.4159 199.807 50.8152 181.269L64.3448 165.942C64.8055 165.435 65.3837 165.048 66.0287 164.816C66.6738 164.584 67.3659 164.514 68.0444 164.612C68.7229 164.71 69.3669 164.973 69.92 165.378C70.473 165.783 70.9183 166.317 71.2165 166.935L79.9362 185.43C85.3779 197.036 94.3474 208.53 106.487 219.481C107.289 220.177 108.135 220.296 108.706 220.288C109.278 220.279 110.142 220.084 110.838 219.282C111.494 218.588 111.756 217.623 111.607 216.702C106.43 185.912 112.006 149.979 128.273 109.794C141.718 76.4133 162.436 49.2923 189.758 29.0217L209.698 14.2674C212.304 12.3265 216.085 14.1137 216.273 17.3732L217.749 42.2032C218.76 59.1702 222.292 73.8929 228.235 85.8104C235.501 100.399 245.124 113.646 256.86 125.212C265.026 133.249 274.069 140.344 283.819 146.363C307.289 160.759 327.199 180.278 342.057 203.46C356.907 226.858 366.154 253.368 369.079 280.926C371.644 305.224 369.34 329.256 362.211 352.444C355.32 374.772 344.167 395.554 329.371 413.639C314.43 431.874 296.443 446.89 275.824 458.176C254.471 469.905 231.29 477.141 206.837 479.723C182.384 482.304 158.204 480.068 134.877 473.109C112.415 466.425 91.4695 455.428 73.2114 440.735C54.7926 426.023 39.684 408.15 28.3165 387.747C16.5224 366.619 9.15539 343.309 6.66488 319.24C4.01258 294.118 6.58439 269.173 14.3995 245.08Z",
    fill: "url(#paint0_linear_630_2432)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_630_2432",
    x: 5.65527,
    y: 13.4639,
    width: 364.438,
    height: 471.298,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_630_2432"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_630_2432",
    result: "effect2_innerShadow_630_2432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_630_2432",
    x1: 182.494,
    y1: 75.1982,
    x2: 183,
    y2: 369.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F84B2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAF9CC",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.c68b48173fae90161faa0aa3f002779f.svg";
export { ForwardRef as ReactComponent };